import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import {useTheme} from "@mui/material/styles";
import React from "react";
import {useTranslation} from "react-i18next";
import useWindowSize from "../../../utility/useWindowSize";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOPicture from "../../fundamentals/CCOPicture";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import TeaserCardCallToAction, {
    CallToActionType
} from "../C020TeaserCarousel/TeaserCardCallToAction";
import {
    cardStyle,
    DESCRIPTION_CHAR_LIMIT,
    HEADER_CHAR_LIMIT
} from "../C020TeaserCarousel/TeaserCardContent";
import {SosDonationCardType} from "../../types";

interface Props {
    item: SosDonationCardType;
    buttonLabel?: string;
    horizontal?: boolean;

}

function C086DonationCardTeaserCardContent(props: Props) {
    const theme = useTheme();
    const {lowerThanWindowMedium} = useWindowSize();
    const {t} = useTranslation();

    const cardContentStyle = {
        'div:last-child': {
            marginBottom: '0 !important'
        },
        'span > div:last-child': {
            marginBottom: '24px !important'
        },
        paddingLeft: lowerThanWindowMedium ? '16px' : '24px',
        paddingTop: lowerThanWindowMedium ? '16px' : '24px',
        height: '100%!important',
        width: '100%!important'
    };

    return (
        <Box id={props.item.id} sx={cardStyle(props, theme.palette.primary.main)}>
            <Box
                sx={{
                    width: "585",
                    height: "329",
                    overflow: 'hidden',
                    "img": {width: '100%!important', height: '100%!important'}
                }}>
                <CCOPicture name={props.item.picture?.name}
                            alt={props.item.picture?.alt ?? ''}
                            picture={props.item.picture}
                            orientation="landscape_ratio16x9" width="585"
                            height="329"/>
            </Box>
            <CardContent sx={cardContentStyle}>
                <CCOHeadline type='h6' propertyName='properties.teaserTitle'
                             metadataId={props.item.id} headline={props.item.teaserTitle}
                             limit={HEADER_CHAR_LIMIT} justify="left"/>
                <CCORichText metadataId={props.item.id} textAsTree={props.item.teaserText?.textAsTree}
                             propertyName="properties.teaserText"
                             charLimit={DESCRIPTION_CHAR_LIMIT}/>
                <TeaserCardCallToAction item={props.item}
                                        callToActionType={CallToActionType.BUTTON}
                                        callToActionCustomText={props.buttonLabel ??
                                                                t("donation_form.donate_now") ??
                                                                undefined}
                                        insideCardWithLink/>
            </CardContent>
        </Box>
    );
}

export default C086DonationCardTeaserCardContent;